import { OrganisationSettings } from "../interfaces/delivery-company/orders";

export const emptyOrgSettings: OrganisationSettings = {
    notification_templates: [],
    custom_primary_color: "",
    branding_message: "",
    brand: "",
    navbar_logo: null,
    default_driver_commission_settlement_mode: 'NET',
    critical_order_surcharge_factor: null
}